import { __decorate, __metadata } from "tslib";
import { ReadonlyStore } from "@fastoche/ui-core/store";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { inject, injectable } from "inversify";
import { filter, take, map } from "rxjs/operators";
import { Logger } from "@leavy/logger";
let SegmentAnalyticsProvider = class SegmentAnalyticsProvider extends ReadonlyStore {
    constructor() {
        super(null);
        this.scheduledQueue = [];
        this.ready$ = this
            .value$
            .pipe(filter(x => x != null))
            .pipe(map(x => x))
            .pipe(take(1));
        this.ready$.subscribe(x => this.onSegmentReady(x));
    }
    onSegmentReady(analytics) {
        this.logger.debug("SegmentAnalyticsProvider is ready");
        void this.dequeueScheduledCalls(analytics);
    }
    schedule(cb) {
        this.scheduledQueue.push(cb);
    }
    async dequeueScheduledCalls(analytics) {
        let callback;
        while ((callback = this.scheduledQueue.shift()) != undefined) {
            try {
                await callback(analytics);
            }
            catch (e) {
                this.logger.warn("Error happened while executing scheduled Segment call", e);
            }
        }
    }
    async load(settings, options) {
        try {
            if (this.value != null)
                return;
            const [analytics, context] = await AnalyticsBrowser.load(settings, options);
            this.set(analytics);
        }
        catch (e) {
            this.logger.warn("Segment loading has failed, tracking will not work");
        }
    }
    async run(cb) {
        if (this.value) {
            await cb(this.value);
        }
        else {
            this.schedule(cb);
        }
    }
};
__decorate([
    inject(Logger),
    __metadata("design:type", Logger)
], SegmentAnalyticsProvider.prototype, "logger", void 0);
SegmentAnalyticsProvider = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], SegmentAnalyticsProvider);
export { SegmentAnalyticsProvider };
//# sourceMappingURL=SegmentAnalyticsProvider.js.map